import React from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { checkPermission } from './guards/can';
import Can from './guards/can';

const colorClasses = {
  'red': 'red-btn',
  'yellow': 'yellow-btn',
  'grey': 'grey-btn',
  'white': 'white-btn',
  'green': 'green-btn',
};

const ArrowButton = ({ color = 'red', ghost, submit, arrow, className, block, permissions, children, ...props }) => {
  let buttonType = colorClasses[color];
  
  if (ghost) {
    buttonType = buttonType.split('-');
    buttonType.splice(1,0,'ghost');
    buttonType = buttonType.join('-');
  }

  let action = true;
  let subjectClass = '';
  let hasPermission = true;
  
  if (permissions) {
    action = permissions.action;
    subjectClass = permissions.subjectClass;
    hasPermission = checkPermission(action,subjectClass);
  }

  if (props.disabled) {
    hasPermission &= !props.disabled;
  }

  return (
    <Can action={!permissions || permissions.mode !== 'hide' || hasPermission} subjectClass={subjectClass}>
      <Button type={submit ? 'submit' : 'button' }
              className={classnames(buttonType, className, {'btn-block': block})}
              {...props}
              disabled={!hasPermission && (!permissions || !permissions.mode || permissions.mode === 'disable')}>
        {arrow && arrow.direction === 'left' && <span className="ignite-icon arrow-left"/>}
        {children}
        {arrow && arrow.direction !== 'left' && <span className="ignite-icon arrow-right"/>}
      </Button>
    </Can>
  );
};

ArrowButton.propTypes = {
  color: PropTypes.oneOf([
    'red','yellow','grey','white', 'green'
  ]),
  ghost: PropTypes.bool,
  submit: PropTypes.bool,
  arrow: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.object
  ]),
  block: PropTypes.bool,
  className: PropTypes.any,
  permissions: PropTypes.shape({
    action: PropTypes.string,
    subjectClass: PropTypes.string,
    mode: PropTypes.oneOf(['hide', 'disable']),
  })
};

ArrowButton.defaultProps = {
  color: 'red',
  ghost: true,
  submit: true,
  block: false,
  arrow: {}
};

export default ArrowButton;



// WEBPACK FOOTER //
// ./src/components/common/button-arrow.jsx